<template name="dateTemplate" lang="html">
    <div class="row">
        <div id="sidebarMenu" class="sidebar sidebar-fixed bg-white">
            <div class="sidebar-header"></div>
            <!-- df-sidebar-header -->
            <div class="sidebar-body"></div>
            <!-- sidebar-body -->
        </div>
        <!-- sidebar -->
        <div class="content content-components">
            <div class="pd-x-0 pd-lg-x-10 pd-xl-x-0">
                <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                                <li class="breadcrumb-item">{{this.mainName}}</li>
                                <li class="breadcrumb-item active" aria-current="page">{{this.subName}}</li>
                            </ol>
                            <h4 class="mg-b-0 tx-spacing--1">{{this.subName}}</h4>
                        </nav>
                    </div>
                    <div class="card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end">
                        <button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f" v-on:click="createData()">
                            <feather type="folder" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Save</button>
                    </div>
                </div>
                <div class="row row-xs">
                    <div class="col-sm-6 col-lg-12">
                        <div class="card card-body flex-column-inherit">
                            <div class="col-sm-6 col-lg-3 d-inline-block">
                                <h6>Menu Depth 1</h6>
                                <div class="list-group">
                                    <div class="list-group-item list-group-item-padding" v-for="(form, i) in setMenu" :key="form.id">
                                        <span class="display-inline-block w-80">{{form.menuName}}</span>
                                        <a href="" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="editDialog(form.id, form.menuDepth)">
                                            <feather type="menu" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <!-- col -->
                            <div class="col-sm-6 col-lg-3" :class="{'d-none': secondDisplay}">
                                <div class="dept-margin-bottom">
                                    <h6 class="display-inline-block">Menu Depth 2</h6>
                                    <feather type="x-square" @click="menuClosed(1)" class="wd-15 hd-15 valign-middle-f svg_overflow float-right closed-cursor"></feather>
                                </div>
                                <div class="list-group">
                                    <div class="list-group-item list-group-item-padding" v-for="(form, i) in secondMenu" :key="form.id">
                                        <span class="display-inline-block w-80">{{form.menuName}}</span>
                                        <a href="" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="editDialog(form.id, form.menuDepth)">
                                            <feather type="menu" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <!-- col -->
                            <div class="col-sm-6 col-lg-3" :class="{'d-none': thridDisplay}">
                                <div class="dept-margin-bottom">
                                    <h6 class="display-inline-block">Menu Depth 3</h6>
                                    <feather type="x-square" @click="menuClosed(2)" class="wd-15 hd-15 valign-middle-f svg_overflow float-right closed-cursor"></feather>
                                </div>
                                <div class="list-group">
                                    <div class="list-group-item list-group-item-padding" v-for="(form, i) in thridMenu" :key="form.menuName">
                                        <span type="email" class="display-inline-block w-80">{{form.menuName}}</span>
                                        <a href="" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="headerSearch(form.id, form.menuName, form.menuRoute)">
                                            <feather type="menu" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <!-- col -->
                        </div>
                    </div>
                </div>
                <!-- row row-xs -->
                <div class="row row-xs mt-1 d-block" v-if="menuSheet.length > 0">
                    <div class="d-none d-md-block tx-right-f mg-xs-y-15-f">
                        <a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5" data-toggle="modal" data-animation="effect-flip-horizontal" @click="sheetAdd(routeData)">
                            <feather type="plus" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Add
                        </a>
                    </div>
                    <div class="list-group overflow-auto">
                        <div class="list-group-item bd-0-f mb-0" v-for="(form, i) in menuSheet">
                            <span class="list-group-item input-group-append fl">
                                <a href="" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="sheetDelete(form.sheetid, i)">
                                    <feather type="trash-2" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
                                </a>
                            </span>
                            <span class="list-group-item input-group-append fl pd-16-f">{{Number(i)+1}}</span>
                            <span class="list-group-item input-group-append fl" :class="{'pd-16-f': form.sheetcode, 'none-code-pd': !form.sheetcode}">{{form.sheetcode}}</span>
                            <input type="text" class="list-group-item input-group-append fl pd-16-f" v-model="form.sheetname" id="sheetname" placeholder='sheetname'>
                            <span class="list-group-item input-group-append fl" :class="{'pd-16-f': form.createdate, 'none-date-pd': !form.createdate}">{{form.createdate}}</span>
                            <span class="list-group-item input-group-append fl">
                                <a href="" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="columnAdd(form.id, i)">
                                    <feather type="plus" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
                                </a>
                            </span>
                            <draggable class="list-group d-webkit-box" :list="form.columns" :group="'sheet'+i" @change="log($event, i)">
                                <span class="list-group-item input-group-append" v-for="(form1, j) in form.columns">{{form1.columnName}}
                                    <a href="#modal6" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="columnData(form1.id, i, j)">
                                        <feather type="edit" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
                                    </a>
                                    <a href="" v-if="form1.columnDivision === 'C'" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="columnDelete(form1.id, i, j)">
                                        <feather type="trash-2" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
                                    </a>
                                </span>
                            </draggable>
                            
                        </div>
                    </div>
                </div>
            </div>
            <!-- container -->
        </div>
        <!-- content -->
        <div class="modal fade z-index-1051" id="modal6" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel6" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h6 class="modal-title" id="exampleModalLabel6">Column Edit</h6>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label class="has-text-weight-semibold">Name</label>
                            <input type="email" class="form-control" :id="editColumn.id" v-model="editColumn.columnName"></div>
                            
                            <!-- <div class="form-group" v-if="editColumn.columnDivision == 'C'"> -->
                            <div class="form-group">
                                <label for="formGroupExampleInput" class=" d-block has-text-weight-semibold">Column Type</label>
                                <div class="ml-2 custom-control custom-radio mb-1 display-inline-block" v-for="(form, i) in defaultType">
                                    <input type="radio" class="custom-control-input" :id="form" :name="form" :value="form" v-model="columnType">
                                        <label class="custom-control-label" :for="form">
                                            {{form}}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="form-group" v-if="columnType=='LIST'">
                                        <label class="has-text-weight-semibold">Code</label>
                                        <b-select placeholder="Select a Code Name" v-model="editColumn.columnCodecode">
                                            <option v-for="form in codeData" :value="form.id" :key="form.id">{{form.codename}}</option>
                                        </b-select>
                                    </div>
                                    <div class="form-group" v-if="columnType=='FIGURE'">
                                        <label class="has-text-weight-semibold">Figure</label>
                                        <!-- <!-- <label class="has-text-weight-semibold">Name</label> -->
                                        <div></div>
                                        <input type="email" class="form-control display-inline-block w-20 text-center" v-model="editColumn.limitMinvalue" placeholder='min'>
										<input type="email" class="form-control display-inline-block w-20 text-center" v-model="editColumn.limitMinInEquality" placeholder='inequality'>
                                        <label class="col-form-label-lg">value</label>
										<input type="email" class="form-control display-inline-block w-20 text-center" v-model="editColumn.limitMaxInEquality" placeholder='inequality'>
										<input type="email" class="form-control display-inline-block w-20 text-center" v-model="editColumn.limitMaxvalue" placeholder='max'>
                                        <!-- <b-select placeholder="Select a FIGURE" v-model="editColumn.columnCodecode">
                                            <option v-for="form in codeData" :value="form.id" :key="form.id">{{form.codename}}</option>
                                        </b-select> -->
                                    </div>
                                    <label class="has-text-weight-semibold">ColumnAttr</label>
                                    <input type="email" class="form-control" v-model="editColumn.columnAttr">
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary tx-13" data-dismiss="modal">Close</button>
                                    <button type="button" class="btn btn-primary tx-13" data-dismiss="modal" @click="columnEdit">Edit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- division modal -->
                </div>
            </template>
<script>
	// 공통 스크립트
	import common from "@/views/Common/common.js";
	// 기본 컬럼 조회
	import dacn from "@/views/Management/Common/defaultColumn.js";
	// Header의 메뉴 정보 호출을 위한 bus event
	import { bus } from "../../../main";
	// vue draggable api import
    import draggable from "vuedraggable";
    //alert, notification
    import { Buefy } from 'buefy';


	export default {
		name: "Department",
		// order: 1,
		props: ['properties'],
		data() {
			return {
				mainName:'',
				subName:'',
				menuData:[], // header.vue data
				menuAll: [],
				 // 부서정보
				setMenu: [], // 초기 Depth Setting
				secondMenu: [],
				thridMenu: [],
				secondDisplay: true,
				thridDisplay: true,

				menuSheet: [],
				routeData: [],
				editColumn: [],
				defaultType: [],
                codeData: [],
                
                columnChangeData: {},
                columnType:'',

                sheetData:{}, //mid, sheettype
                defaultMenuSheet: [],//원본 데이터 처음 불러올때
                delSheetIds:[], // 시트 지워야할 ids 
                delColumnsIds:[], //컬럼 지워야할 ids

                editFlag: true,
			}
		},
		beforeDestroy(){
			bus.$off('menu_data')
		},
		created(){
			bus.$on('menu_data', (data)=>{
				this.menuData = data;
				this.classifyMenu();
			});
		},
		mounted() {
		},
		components: {
			draggable,
			dacn
		},
		methods: {
			/*
			* 화면 로딩 시 기본 메뉴, 컬럼 타입 등 필요한 정보를 설정한다.
			*/
			async classifyMenu(){
				let data = common.menuHeader(this.properties.mid, this.menuData);
				this.mainName = data[0];
                this.subName = data[1];
                await this.$axios.get(this.$apiHost + "/menus")
				.then(res => {
                    this.menuAll = res.data;
				})
				this.menuAll.sort((a, b)=>{return a.menuDepth - b.menuDepth;}); // 정렬 이후 make data
				this.menuAll.forEach(a=>{
					if(Number(a.menuDepth) === 1) this.setMenu.push(a);
				}); // dept Setting
				this.setMenu.sort((a, b)=>{return a.menuSort - b.menuSort;}); // setDept sort

				this.defaultType = dacn.defaultType(); // 컬럼 타입 출력 (defaultColumn.js에 설정 변경이 용이함)
				this.codeSearch();// 코드 출력
			},
			/*
			* 시트 추가  (DB에서 기본 시트 컬럼을 가져오는게 아니라 defaultColumn.js에서 설정한 값을 가져온다. 변경이 용이해서 js 파일에 설정)
			*/
			sheetAdd: function(routeData) {
                if (routeData[1]) {
                    this.editFlag = false;
                    let dData = dacn.sheetSearch(routeData);
                    for (let i in dData.columns) {
                        dData.columns[i].columnSort = Number(i)+2;
                    }
                    this.menuSheet.push(dData);
                } else {
                    this.$buefy.dialog.alert({
                        message: 'Please add route first.',
                        size: 'is-medium'
                    })
                }
            },
            async createData() {
                try {
                //mid, list
            
                for (let i in this.menuSheet) {
                    for (let j in this.menuSheet[i].columns) {
                        if (!this.menuSheet[i].columns[j].columnType) {
                            this.$buefy.dialog.alert({
                                message: 'Please enter column type.',
                                size: 'is-medium',
                                type: 'is-danger'
                            });
                            return false;
                        }
                    }
                }

                //추가인지 수정인지?(sheetId 있는지 없는지 )
                let addData = [];
                addData = this.menuSheet.filter(item => !item.sheetid) //추가 시트 데이터, 컬럼 데이터
                let changeData = [];
                changeData = this.menuSheet.filter(item => item.sheetid) //수정 데이터 , defaultMenuSheet 와 비교 후 가공 필요
              
                const params = {
                    mid: this.sheetData.mid,
                    sheetType: this.sheetData.gubun,
                    changeData: changeData,
                    addData: addData,
                    delData: {sheetDel: this.delSheetIds, columnDel: this.delColumnsIds}
                }
                //sheet에 연결 
                const create = await this.$axios.post(this.$apiHost + '/sheets', params);
                if (create.status == 200){
                    this.$buefy.dialog.alert({
                        message: create.data.msg,
                        size: 'is-medium',
                    });
                    this.headerSearch(this.sheetData.mid, this.sheetData.gubun, this.routeData[0]);
                    this.editFlag = true;
                    return false;
                }
                } catch (error) {
                    console.log(error)                    
                }
            },
			/*
			* 시트 수정 (저장 시)
			*/
			sheetEdit: function() {
				
			},
			/*
			* 시트 사용 안함
			*/
			sheetDelete: function(sid, idx) {
                this.editFlag = false;
                if (this.menuSheet[idx].sheetid) {
                    this.delSheetIds.push(sid);
                } 
                this.menuSheet.splice(idx, 1);

			},
			/*
			* 시트 내 컬럼 추가
			*/
			columnAdd: function(id, idx) {
                this.editFlag = false;
                this.menuSheet[idx].columns.push({columnName: 'Default', columnAttr: '', columnDivision:'C', columnType: '',
                        codes:[], columnSort: this.menuSheet[idx].columns.length+2});
			},
			/*
			* 시트 내 컬럼 수정 시 기본 정보 출력 
			*/
			columnData: function(id, sidx, cidx) {
                this.editColumn = [];
                this.columnChangeData = [];
				if(common.isNull(id)){
					this.menuSheet[sidx].columns.some((a, b)=>{
						if(b === cidx) this.editColumn = a
					})
				}else{
					this.menuSheet[sidx].columns.some(a=>{
						if(a.id === id) {
							this.editColumn = a;
							return true;
						}
					});
                }
                this.columnChangeData = {
                    sidx: sidx,
                    cidx: cidx,
                    id: id
                }
                this.columnType = this.editColumn.columnType;

			},
			/*
			* 시트 내 컬럼 수정
			*/
			columnEdit: function(id) {
                this.editFlag = false;
                let changeColumns = [];
                this.editColumn.columnType = this.columnType;
			},
			/*
			* 시트 내 컬럼 사용안함
			*/
			columnDelete: function(id, sidx, cidx) {

                if (id) {
                    this.delColumnsIds.push(id);
                    this.editFlag = false;
                }
                this.menuSheet[sidx].columns.splice(cidx, 1);

                for (let i in this.menuSheet[sidx].columns) { //순서대로 소트 재정렬
                    this.menuSheet[sidx].columns[i].columnSort = Number(i)+2;
                }
			},
			/*
			* 메뉴 뎁스 숨기기 
			*/
			sheetClosed: function(gubun) {
				if(gubun === 1) this.secondDisplay = true;
				else this.thridDisplay = true;
            },
            menuClosed: function(gubun) {
                if(gubun === 1) {
                    this.secondDisplay = true;
                } else {
                    this.secondDisplay = false;
                    this.thridDisplay = true;
                }
			},
			/*
			* 단계 이동 : 메뉴 뎁스를 총 3 뎁스(list, detail)로 설정하고 가는 상황으로 그 이상은 안됨
			*/
			nextMenu: function(parentId, menuDepth) {
                this.menuSheet = [];
                if (menuDepth === 1) {
                    this.secondDisplay = false;
                    this.thridDisplay = true;
                    this.secondMenu = [];
                    this.thridMenu = [];
                    this.menuAll.forEach(a=>{
                        if (a.parentId === parentId) this.secondMenu.push(a);
                    });
                    this.secondMenu.sort((a,b)=>{return a.menuSort - b.menuSort;});
                    if (this.secondMenu.length === 0) {
                        this.$buefy.dialog.alert({
                            message: 'Please add second menu first.',
                            size: 'is-medium'
                        })
                        // this.classifyMenu();
                    }
                }else if (menuDepth === 2) {
                    this.thridDisplay = false;
                    this.thridMenu = [];
                    this.menuAll.forEach(a=>{
                        if (a.id === parentId) {
                            this.thridMenu.push({id:parentId, menuRoute: a.menuRoute, menuName: 'list', menuSort:'1'});
                            this.thridMenu.push({id:parentId, menuRoute: a.menuRoute, menuName: 'detail', menuSort:'2'});
                        }
                    });
                }

			},
			log: function(evt, idx) {
                this.editFlag = false;
                for (let i in this.menuSheet[idx].columns) { //순서대로 소트 재정렬
                    this.menuSheet[idx].columns[i].columnSort = Number(i)+2;
                }
            },
            editDialog(id, depth) {
                if (this.editFlag == false) {
                    this.$buefy.dialog.confirm({
                        message: "Do you want to save the changes?",
                        size: 'is-medium',
                        onConfirm: async () => {
                            this.editFlag = true;
                            this.nextMenu(id, depth);
                        }
                    });
                } else {
                    this.nextMenu(id, depth);
                }
            },
			/*
			* 헤더 데이터 조회 및 출력
			*/
			async headerSearch(mid, name, route){
                // menuid (mid)에 있는 sheet를 모두 가져 온다
				let header = [];
				let key = '';
				let idx_a = [];
				this.menuSheet = [];
				this.routeData = [route, name];
                var params = [];
				params = {'mid' : mid, 'gubun' : name};
                this.sheetData = params;
				var request = {params : params}
				await this.$axios.get(this.$apiHost + '/sheets/all', request)
				.then(res=>{
                    this.menuSheet = res.data;
                    this.defaultMenuSheet = res.data;
                    this.menuSheet.sort((a, b)=>{return a.sheetcode.replace(/[^0-9]/g, "") - b.sheetcode.replace(/[^0-9]/g, "");}); 
                    if (this.menuSheet.length == 0) {
                        let dData = dacn.sheetSearch(this.routeData);
                        if (dData.length == 0) {
                            this.$buefy.dialog.alert({
                                message: 'Please check out defaultColumn.js',
                                size: 'is-small',
                                type: 'is-danger'
                            });
                            return false;
                        }
                        for (let i in dData.columns) {
                            dData.columns[i].columnSort = Number(i)+2;
                        }
                        this.menuSheet.push(dData);
                    }
				}).catch(err=>{console.log(err)});
			},
			/*
			* 컬럼 수정 시 필요한 code 값 출력
			*/
			async codeSearch(){
				await this.$axios.get(this.$apiHost + '/codes')
				.then(res => {
					this.codeData = res.data;
				}).catch(err=>{console.log(err)});
			},
		},
		computed: {
			draggingInfo() {
				return this.dragging ? "under drag" : "";
			},
		},
		watch: {
		},
	}
</script>
<style scoped>
	@import "../../../assets/css/buefy.css";
</style>



// WEBPACK FOOTER //
// src/views/Management/Sheet/List.vue